var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Warehouse.BatchMaintenance"),
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticClass: "spacing" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.onMaintenanceTypeChanged },
                  model: {
                    value: _vm.maintenanceType,
                    callback: function($$v) {
                      _vm.maintenanceType = $$v
                    },
                    expression: "maintenanceType"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "all" } }, [
                    _vm._v(_vm._s(_vm.$t("Warehouse.maintenanceAllType")))
                  ]),
                  _c("el-radio", { attrs: { label: "containerNo" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Warehouse.maintenanceContainerNoType"))
                    )
                  ]),
                  _c("el-radio", { attrs: { label: "weightAndSize" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Warehouse.maintenanceWeightAndSizeType"))
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            { attrs: { "label-width": "120px", "label-position": "right" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("Warehouse.boxNum")))]
                          ),
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { no: "boxesNumber" },
                            on: { input: _vm.onInputBoxNumber },
                            model: {
                              value: _vm.fillData.boxesNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.fillData, "boxesNumber", $$v)
                              },
                              expression: "fillData.boxesNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.maintenanceAllOrNoType
                    ? _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s(_vm.$t("Warehouse.boxSeq")))]
                              ),
                              _c(
                                "el-select",
                                {
                                  style: {
                                    width: _vm.$selectByLang(
                                      "80px",
                                      "80px",
                                      "80px",
                                      "120px",
                                      "100px",
                                      "100px"
                                    ),
                                    marginRight: "8px"
                                  },
                                  model: {
                                    value: _vm.fillData.boxSeqLen,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fillData, "boxSeqLen", $$v)
                                    },
                                    expression: "fillData.boxSeqLen"
                                  }
                                },
                                _vm._l(_vm.types, function(item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-right": "8px"
                                },
                                attrs: { no: "startSeq" },
                                on: { input: _vm.onInputStartSeq },
                                model: {
                                  value: _vm.fillData.startSeq,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "startSeq", $$v)
                                  },
                                  expression: "fillData.startSeq"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-family":
                                      "'Open Sans', Arial, sans-serif"
                                  }
                                },
                                [_vm._v("——")]
                              ),
                              _c("el-input", {
                                staticStyle: {
                                  width: "50px",
                                  "margin-left": "8px"
                                },
                                attrs: { no: "endSeq", disabled: "" },
                                model: {
                                  value: _vm.fillData.endSeq,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "endSeq", $$v)
                                  },
                                  expression: "fillData.endSeq"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.maintenanceAllOrNoType
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Warehouse.PerContainerNo"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { no: "shipmentId" },
                                model: {
                                  value: _vm.fillData.shipmentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "shipmentId", $$v)
                                  },
                                  expression: "fillData.shipmentId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "PO Number:" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "228px" },
                                attrs: { no: "poNumber" },
                                model: {
                                  value: _vm.fillData.poNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "poNumber", $$v)
                                  },
                                  expression: "fillData.poNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.maintenanceAllOrSizeType
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ChineseCargoName"
                                      ) + ":"
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { no: "cargoChineseName" },
                                model: {
                                  value: _vm.fillData.cargoChineseName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fillData,
                                      "cargoChineseName",
                                      $$v
                                    )
                                  },
                                  expression: "fillData.cargoChineseName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_EnglishCargoName"
                                      ) + ":"
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "228px" },
                                attrs: { no: "cargoEnglishName" },
                                model: {
                                  value: _vm.fillData.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fillData,
                                      "cargoEnglishName",
                                      $$v
                                    )
                                  },
                                  expression: "fillData.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.maintenanceAllOrSizeType
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Warehouse.DialogSingleBoxWeight"
                                      ) + ":"
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { no: "singleBoxWeight" },
                                model: {
                                  value: _vm.fillData.singleBoxWeight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fillData,
                                      "singleBoxWeight",
                                      $$v
                                    )
                                  },
                                  expression: "fillData.singleBoxWeight"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Warehouse.BoxSize") + ":")
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "68px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "Warehouse.boxLengthPlaceholder"
                                  ),
                                  no: "boxLength"
                                },
                                model: {
                                  value: _vm.fillData.boxLength,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "boxLength", $$v)
                                  },
                                  expression: "fillData.boxLength"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: { width: "68px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "Warehouse.boxWidthPlaceholder"
                                  ),
                                  no: "boxWidth"
                                },
                                model: {
                                  value: _vm.fillData.boxWidth,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "boxWidth", $$v)
                                  },
                                  expression: "fillData.boxWidth"
                                }
                              }),
                              _c("el-input", {
                                staticStyle: {
                                  width: "68px",
                                  "margin-right": "8px"
                                },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "Warehouse.BoxHeightPlaceholder"
                                  ),
                                  no: "BoxHeight"
                                },
                                model: {
                                  value: _vm.fillData.boxHeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fillData, "boxHeight", $$v)
                                  },
                                  expression: "fillData.boxHeight"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-family":
                                      "'Open Sans', Arial, sans-serif"
                                  }
                                },
                                [_vm._v("CM")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-form",
            { staticClass: "spacing" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.fillDataHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Warehouse.FillData")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.clearDataHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.delDetailHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteCargo")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                ref: "maintenanceAllTypeTable",
                staticStyle: { "min-height": "350px" },
                attrs: {
                  "config-module": "9300015",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.maintenanceAllTypeColumn,
                  "row-data": _vm.detailList
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "save" },
                  on: { click: _vm.saveCallBack }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.containerNoEditor.visible
        ? _c("container-no-editor", {
            attrs: {
              visible: _vm.containerNoEditor.visible,
              "shipment-id": _vm.containerNoEditor.shipmentId,
              "warehouse-in-detail-list": _vm.detailList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.containerNoEditor, "visible", $event)
              },
              detailSaveCallBack: _vm.containerNoEditor.detailSaveCallBack,
              close: function($event) {
                _vm.containerNoEditor.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }